import { render, staticRenderFns } from "./ReportForm.vue?vue&type=template&id=0bc79b3e"
import script from "./ReportForm.vue?vue&type=script&lang=ts"
export * from "./ReportForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports